import { useEffect, useState } from 'react'
import './offline.scss'
export const OfflineUser = () => {

    const [offline, setOffline] = useState(false)

    useEffect(() => {
        window.addEventListener('offline', () => setOffline(true))
        return () => {
            window.removeEventListener('offline', () => setOffline(true))
        }
    }, [])
    return (
        <>
            {
                offline && <div className='a-offline'>
                    <span className='a-offline__message'>You are offline</span>
                </div>
            }
        </>
    )
}
